import StyleModel from './StyleModel';

export {
    StyleModel
};



// WEBPACK FOOTER //
// ./~/@girder/histomicsui/models/index.js